<template>
  <section class="box">
    <div class="edit-product">
      <h2>{{ isNewProduct ? 'הוספת מוצר חדש' : 'עריכת מוצר' }}</h2>
      <v-form @submit.prevent="saveProduct" v-model="isFormValid">
        <div class="form-grid">
          <v-text-field
            v-model="product.name"
            label="שם המוצר"
            :rules="[v => !!v || 'שם המוצר הוא שדה חובה']"
            required
          ></v-text-field>

          <v-text-field
            v-model="product.price"
            label="מחיר"
            type="number"
            :rules="[
              v => !!v || 'מחיר הוא שדה חובה',
              v => v > 0 || 'המחיר חייב להיות גדול מ-0'
            ]"
            required
          ></v-text-field>

          <v-select
            v-model="product.categoryId"
            :items="categories"
            item-title="name"
            item-value="id"
            label="קטגוריה"
            :rules="[v => !!v || 'קטגוריה היא שדה חובה']"
            required
          ></v-select>

          <v-text-field
            v-model="product.stock"
            label="מלאי"
            type="number"
            :rules="[v => v >= 0 || 'המלאי לא יכול להיות שלילי']"
          ></v-text-field>

          <v-textarea
            v-model="product.description"
            label="תיאור המוצר"
            rows="4"
          ></v-textarea>

          <div class="image-upload">
            <v-file-input
              v-model="imageFile"
              accept="image/*"
              label="תמונת מוצר"
              prepend-icon="mdi-camera"
              @change="handleImageChange"
            ></v-file-input>
            <img
              v-if="product.imageUrl || imagePreview"
              :src="imagePreview || product.imageUrl"
              class="preview-image"
            />
          </div>
        </div>

        <div class="actions">
          <v-btn
            type="submit"
            color="primary"
            :disabled="!isFormValid"
            class="mainColorBtn"
          >
            {{ isNewProduct ? 'הוסף מוצר' : 'שמור שינויים' }}
          </v-btn>
          <v-btn @click="cancel" variant="outlined" class="mx-2">
            ביטול
          </v-btn>
        </div>
      </v-form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EditProduct',
  data() {
    return {
      isFormValid: false,
      imageFile: null,
      imagePreview: null,
      product: {
        name: '',
        price: '',
        categoryId: '',
        stock: 0,
        description: '',
        imageUrl: '',
      },
    };
  },
  computed: {
    ...mapGetters(['categories']),
    productId() {
      return this.$route.params.id;
    },
    isNewProduct() {
      return !this.productId;
    },
  },
  async mounted() {
    await this.$store.dispatch('fetchCategories');
    if (!this.isNewProduct) {
      await this.fetchProduct();
    }
  },
  methods: {
    async fetchProduct() {
      try {
        const product = await this.$store.dispatch('fetchProduct', this.productId);
        this.product = { ...product };
      } catch (error) {
        console.error('Error fetching product:', error);
        this.$router.push('/admin');
      }
    },
    handleImageChange(file) {
      if (!file) {
        this.imagePreview = null;
        return;
      }
      
      const reader = new FileReader();
      reader.onload = e => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async saveProduct() {
      try {
        const formData = new FormData();
        Object.keys(this.product).forEach(key => {
          formData.append(key, this.product[key]);
        });
        
        if (this.imageFile) {
          formData.append('image', this.imageFile);
        }

        await this.$store.dispatch(
          this.isNewProduct ? 'createProduct' : 'updateProduct',
          {
            id: this.productId,
            data: formData
          }
        );

        this.$router.push('/admin');
      } catch (error) {
        console.error('Error saving product:', error);
      }
    },
    cancel() {
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped lang="scss">
.edit-product {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;

  h2 {
    margin-bottom: 30px;
    color: $primaryTextColor;
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .image-upload {
    grid-column: 1 / -1;

    .preview-image {
      max-width: 200px;
      max-height: 200px;
      object-fit: contain;
      margin-top: 10px;
    }
  }

  .actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
